module.exports = __webpack_public_path__ + "static/media/CLOSE_ICON.0c67ad14.svg";